import { useState } from 'react'
import { useAppSelector, useAppDispatch } from '../../hooks/useAppDispatch'
import { logout } from '../../store/slices/authSlice'
import { useNavigate } from 'react-router-dom'
import { api } from '../../lib/apiClient'
import { ENDPOINTS } from '../../lib/endpoints'
import { COLOR_ERROR } from '../../lib/config'
import { Button, Card, Divider } from '../../components/ui'
import s from '../../styles/pages/SettingsPage.module.css'

export function SettingsAccount() {
  const { user, accessToken } = useAppSelector((s) => s.auth)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [deletingAccount, setDeletingAccount] = useState(false)

  const handleDeleteAccount = async () => {
    const confirmed = window.confirm(
      'Are you sure you want to delete your account?\n\nThis is permanent — all your discussions, comments, and data will be removed.'
    )
    if (!confirmed) return
    if (window.prompt('Type DELETE to confirm:') !== 'DELETE') return
    setDeletingAccount(true)
    try {
      await api.delete('users', ENDPOINTS.users.deleteMe, accessToken)
      dispatch(logout())
      void navigate('/')
    } catch {
      setDeletingAccount(false)
      window.alert('Failed to delete account. Please try again.')
    }
  }

  if (!user) return null

  return (
    <Card>
      <div className={s.accountTitle}>Account Info</div>
      <div className={s.accountInfo}>
        <div><strong>Email:</strong> {user.email}</div>
        <div><strong>Role:</strong> {user.roles.join(', ')}</div>
      </div>

      <Divider />

      <div className={s.dangerTitle} style={{ color: COLOR_ERROR }}>⚠️ Danger Zone</div>
      <p className={s.dangerDesc}>Deleting your account is permanent and cannot be undone.</p>
      <Button variant="danger" onClick={() => void handleDeleteAccount()} loading={deletingAccount}>
        Delete my account
      </Button>
    </Card>
  )
}
